import { render, staticRenderFns } from "./Milestones-Attachment.vue?vue&type=template&id=f20f7e82"
import script from "./Milestones-Attachment.vue?vue&type=script&lang=js"
export * from "./Milestones-Attachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports